import { Box, Grid, Typography } from "@material-ui/core";
import RefundEventSettingsForm from "./refundEventSettingsForm";

export default function RefundEventSettingsEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Refund &gt; Edit Event
        </Typography>
      </Box>
      <Grid container xs={6}>
        <RefundEventSettingsForm
          description="Edit Event"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
